<template>
    <div class="wpb_content staalwijzer">
        <div class="staalwijzer-body">

            <div class="sidebar-filters-toggle">filteren</div>
            <aside class="left-sidebar">
                <h1 class="left-sidebar-heading">Staalwijzer</h1>
                <form action="">
                    <!-- Categorieen -->
                    <div class="filter-section active">

                        <div class="filter-section-header">
                            <h5>
                                <i class="fas fa-times fa-reset-filter" v-show="data.category != 0"
                                   @click="emptyCategoryArrays"></i>
                                Categorieën
                            </h5>
                            <div class="filter-collapse-btn"></div>
                        </div>
                        <div class="filter-section-body sidebar-categories active">
                            <ul>
                                <li>
                                    <label>
                                        <span>Gereedschapsstaal</span>
                                        <input type="checkbox" value="gss" v-model="category">
                                        <strong class="category-checkbox"></strong>
                                    </label>
                                </li>
                                <li>
                                    <label>
                                        <span>PM Stalen</span>
                                        <input type="checkbox" value="pm_stalen" v-model="category">
                                        <strong></strong>
                                    </label>
                                </li>
                                <li>
                                    <label>
                                        <span>Roestvrijstaal</span>
                                        <input type="checkbox" value="roestvrijstaal" v-model="category">
                                        <strong></strong>
                                    </label>
                                </li>
                                <li>
                                    <label>
                                        <span>Titaan & Nikkel</span>
                                        <input type="checkbox" value="titaan_nikkel" v-model="category">
                                        <strong></strong>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- Gebruikshardheid -->
                    <div class="filter-section range-slider active">
                        <div class="filter-section-header" @click="showGebruikshardheid = !showGebruikshardheid">
                            <!--<i class="fas fa-times fa-reset-filter"  @click="gebruikshardheidData.value = [20,70]"></i>-->
                            <h5>Gebruikshardheid
                                <small>Na eventuele warmtebehandeling</small>
                            </h5>
                            <div class="filter-collapse-btn"
                                 @click="showGebruikshardheid = !showGebruikshardheid"></div>
                        </div>
                        <div class="filter-section-body">
                            <vue-slider v-bind="gebruikshardheidData" ref="gebruikshardheid"
                                        v-model="gebruikshardheidData.value"></vue-slider>
                            <div class="slider-ranges clearfix">
                                <span class="limit">0 HRC</span>
                                <span class="limit">70 HRC</span>
                            </div>
                        </div>
                    </div>
                    <!-- Trekvastheid -->
                    <div class="filter-section range-slider active">
                        <div class="filter-section-header" @click="showTrekvastheid = !showTrekvastheid">
                            <!--<i class="fas fa-times fa-reset-filter" @click="trekvastheidData.value = [200,1200]"></i>-->
                            <h5>Trekvastheid
                                <small>In leveringstoestand</small>
                            </h5>
                            <div class="filter-collapse-btn" @click="showTrekvastheid = !showTrekvastheid"></div>
                        </div>
                        <div class="filter-section-body">
                            <vue-slider v-bind="trekvastheidData" ref="trekvastheid"
                                        v-model="trekvastheidData.value"></vue-slider>
                            <div class="slider-ranges clearfix">
                                <span class="limit">0 N/mm2</span>
                                <span class="limit">1400 N/mm2</span>
                            </div>
                        </div>
                    </div>
                    <!-- Verspaanbaarheid -->
                    <div class="filter-section rating">
                        <div class="filter-section-header">
                            <h5>
                                <i class="fas fa-times fa-reset-filter" v-show="data.verspaanbaarheid != 0"
                                   @click="data.verspaanbaarheid = 0"></i>
                                Verspaanbaarheid
                            </h5>
                            <div class="filter-collapse-btn"></div>
                        </div>
                        <div class="filter-section-body">
                            <div class="clearfix">
                                <input id="verspaanbaarheid5" type="radio" v-model="data.verspaanbaarheid"
                                       name="verspaanbaarheid" class="rating-circle" value="80">
                                <label for="verspaanbaarheid5"></label>

                                <input id="verspaanbaarheid4" type="radio" v-model="data.verspaanbaarheid"
                                       name="verspaanbaarheid" class="rating-circle" value="60">
                                <label for="verspaanbaarheid4"></label>

                                <input id="verspaanbaarheid3" type="radio" v-model="data.verspaanbaarheid"
                                       name="verspaanbaarheid" class="rating-circle" value="40">
                                <label for="verspaanbaarheid3"></label>

                                <input id="verspaanbaarheid2" type="radio" v-model="data.verspaanbaarheid"
                                       name="verspaanbaarheid" class="rating-circle" value="20">
                                <label for="verspaanbaarheid2"></label>

                                <input id="verspaanbaarheid1" type="radio" v-model="data.verspaanbaarheid"
                                       name="verspaanbaarheid" class="rating-circle" value="0">
                                <label for="verspaanbaarheid1"></label>
                            </div>
                        </div>
                    </div>
                    <!-- Taaiheid -->
                    <div class="filter-section rating">
                        <div class="filter-section-header">
                            <h5>
                                <i class="fas fa-times fa-reset-filter" v-show="data.taaiheid != 0"
                                   @click="data.taaiheid = 0"></i>
                                Taaiheid
                            </h5>
                            <div class="filter-collapse-btn"></div>
                        </div>
                        <div class="filter-section-body">
                            <div class="clearfix">

                                <input id="taaiheid5" type="radio" v-model="data.taaiheid" name="taaiheid"
                                       class="rating-circle" value="80">
                                <label for="taaiheid5"></label>

                                <input id="taaiheid4" type="radio" v-model="data.taaiheid" name="taaiheid"
                                       class="rating-circle" value="60">
                                <label for="taaiheid4"></label>

                                <input id="taaiheid3" type="radio" v-model="data.taaiheid" name="taaiheid"
                                       class="rating-circle" value="40">
                                <label for="taaiheid3"></label>

                                <input id="taaiheid2" type="radio" v-model="data.taaiheid" name="taaiheid"
                                       class="rating-circle" value="20">
                                <label for="taaiheid2"></label>

                                <input id="taaiheid1" type="radio" v-model="data.taaiheid" name="taaiheid"
                                       class="rating-circle" value="0">
                                <label for="taaiheid1"></label>
                            </div>
                        </div>
                    </div>
                   <!-- Slijtvastheid -->
                    <div class="filter-section rating">
                        <div class="filter-section-header">
                            <h5>
                                <i class="fas fa-times fa-reset-filter" v-show="data.slijtvastheid != 0"
                                   @click="data.slijtvastheid = 0"></i>
                                Slijtvastheid
                            </h5>
                            <div class="filter-collapse-btn"></div>
                        </div>
                        <div class="filter-section-body">
                            <div class="clearfix">

                                <input id="slijtvastheid5" type="radio" v-model="data.slijtvastheid"
                                       name="slijtvastheid" class="rating-circle" value="80">
                                <label for="slijtvastheid5"></label>

                                <input id="slijtvastheid4" type="radio" v-model="data.slijtvastheid"
                                       name="slijtvastheid" class="rating-circle" value="60">
                                <label for="slijtvastheid4"></label>

                                <input id="slijtvastheid3" type="radio" v-model="data.slijtvastheid"
                                       name="slijtvastheid" class="rating-circle" value="40">
                                <label for="slijtvastheid3"></label>

                                <input id="slijtvastheid2" type="radio" v-model="data.slijtvastheid"
                                       name="slijtvastheid" class="rating-circle" value="20">
                                <label for="slijtvastheid2"></label>

                                <input id="slijtvastheid1" type="radio" v-model="data.slijtvastheid"
                                       name="slijtvastheid" class="rating-circle" value="0">
                                <label for="slijtvastheid1"></label>
                            </div>
                        </div>
                    </div>
                   <!-- Maatvastheid -->
                    <div class="filter-section rating">
                        <div class="filter-section-header">
                            <h5>
                                <i class="fas fa-times fa-reset-filter" v-show="data.maatvastheid != 0"
                                   @click="data.maatvastheid = 0"></i>
                                Maatvastheid
                            </h5>
                            <div class="filter-collapse-btn"></div>
                        </div>
                        <div class="filter-section-body">
                            <div class="clearfix">

                                <input id="maatvastheid5" type="radio" v-model="data.maatvastheid" name="maatvastheid"
                                       class="rating-circle" value="80">
                                <label for="maatvastheid5"></label>

                                <input id="maatvastheid4" type="radio" v-model="data.maatvastheid" name="maatvastheid"
                                       class="rating-circle" value="60">
                                <label for="maatvastheid4"></label>

                                <input id="maatvastheid3" type="radio" v-model="data.maatvastheid" name="maatvastheid"
                                       class="rating-circle" value="40">
                                <label for="maatvastheid3"></label>

                                <input id="maatvastheid2" type="radio" v-model="data.maatvastheid" name="maatvastheid"
                                       class="rating-circle" value="20">
                                <label for="maatvastheid2"></label>

                                <input id="maatvastheid1" type="radio" v-model="data.maatvastheid" name="maatvastheid"
                                       class="rating-circle" value="0">
                                <label for="maatvastheid1"></label>
                            </div>
                        </div>
                    </div>
                   <!-- Corrosie bestendig -->
                    <div class="filter-section rating">
                        <div class="filter-section-header">
                            <h5>
                                <i class="fas fa-times fa-reset-filter" v-show="data.corrosiebestendigheid != 0"
                                   @click="data.corrosiebestendigheid = 0"></i>
                                Corrosie bestendig
                            </h5>
                            <div class="filter-collapse-btn"></div>
                        </div>
                        <div class="filter-section-body">
                            <div class="clearfix">

                                <input id="corrosiebestendigheid5" type="radio" v-model="data.corrosiebestendigheid"
                                       name="corrosiebestendigheid" class="rating-circle" value="80">
                                <label for="corrosiebestendigheid5"></label>

                                <input id="corrosiebestendigheid4" type="radio" v-model="data.corrosiebestendigheid"
                                       name="corrosiebestendigheid" class="rating-circle" value="60">
                                <label for="corrosiebestendigheid4"></label>

                                <input id="corrosiebestendigheid3" type="radio" v-model="data.corrosiebestendigheid"
                                       name="corrosiebestendigheid" class="rating-circle" value="40">
                                <label for="corrosiebestendigheid3"></label>

                                <input id="corrosiebestendigheid2" type="radio" v-model="data.corrosiebestendigheid"
                                       name="corrosiebestendigheid" class="rating-circle" value="20">
                                <label for="corrosiebestendigheid2"></label>

                                <input id="corrosiebestendigheid1" type="radio" v-model="data.corrosiebestendigheid"
                                       name="corrosiebestendigheid" class="rating-circle" value="0">
                                <label for="corrosiebestendigheid1"></label>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="sidebar-filters-tag">filteren</div>
            </aside>

            <div class="staalwijzer-content">
                <div class="staalwijzer-flex">
                    <div class="staalwijzer-header-buttons">
                        <button v-show="!availableToCompare" @mouseover="compareButtonHovered = true" @mouseleave="compareButtonHovered = false" class="specify-btn verge-btn compare-popup" v-bind:class="{'compare-inactive': availableToCompare}">
                            <span>VERGELIJKEN</span>
                        </button>
                        <button v-show="availableToCompare" @mouseover="compareButtonHovered = true" @mouseleave="compareButtonHovered = false" class="specify-btn verge-btn" v-bind:class="{'compare-inactive': availableToCompare}">
                            <span v-show="!compareButtonHovered">VERGELIJKEN</span>
                            <span class="compare-select-text" v-show="compareButtonHovered">SELECTEER MINIMAAL TWEE PRODUCTEN</span>
                        </button>
                    </div>

                    <div class="staalwijzer-header-filters clearfix">
                        <!--<input type="search" placeholder="Zoek werkstofnummer">-->

                        <!--<div class="search-container" style="margin-left:-300px; margin-right:320px;">-->
                        <!--<input type="search" v-model="searchName" placeholder="Zoek werkstofnummer">-->
                        <!--<div class="search-results-container" v-show="searchName != ''">-->
                        <!--<ul class="search-results-list">-->
                        <!--<li v-for="activeSteel in names">-->
                        <!--<a :hr  ef="'/staalwijzer/detail/'+activeSteel.id"> {{activeSteel.name}} </a>-->
                        <!--</li>-->
                        <!--</ul>-->
                        <!--</div>-->
                        <!--</div>-->

                        <div class="search-container">
                            <input type="search" v-model="searchType" placeholder="Zoek op kwaliteiten">
                            <div class="search-results-container" v-show="searchType != ''">
                                <ul class="search-results-list">
                                    <li v-if="IsFromSearchTerms[0]">Komt overeen met:</li>
                                    <li v-for="activeSteel in qualities">
                                        <a :href="'/staalwijzer/detail/'+activeSteel.slug"> {{activeSteel.type}} - {{activeSteel.name}} </a>
                                    </li>
                                    <li v-if="! qualities[0]">Geen resultaten gevonden</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
                <div v-for="activeSteel in activeSteels" class="staalwijzer-box">
                    <label class="check-lbl" :for="'checkbox'+activeSteel.id">
                        <input type="checkbox" :name="'checkbox'+activeSteel.id" v-bind:disabled="maxCompareReached && notInCompare(activeSteel)" :checked="! notInCompare(activeSteel)">
                        <div class="checkbox" :id="activeSteel.id" @click="addRemoveCompare(activeSteel)" :key="activeSteel.id">
                        </div>
                    </label>
                    <a :href="'/staalwijzer/detail/'+activeSteel.slug" @click="saveFilter()" style="text-decoration: none;">
                        <div class="staalwijzer-details">
                            <h4>{{ activeSteel.type }}</h4>
                            <p class="code">{{ activeSteel.name }}</p>
                            <span class="number">{{ activeSteel.aisi }}</span>
                            <!--<p class="code">{{ activeSteel.soort }}</p>-->
                            <div class="right-arrow"></div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="ie-clearfix"></div>
        </div>

        <modal v-bind:steels="compareItems"></modal>
    </div>

</template>
<script>

    import VueSliderComponent from "vue-slider-component";
    import filter from "./helpers/filter";

    var SortedArray = require("collections/sorted-array");

    export default {
        components: {
            'vue-slider': VueSliderComponent
        },
        props: [
            'steels'
        ],
        data: function () {
            return {
                compareButtonHovered: false,
                showTrekvastheid: false,
                showGebruikshardheid: false,

                allSteels: new SortedArray(),

                filtered: false,
                searchType: "",
                searchName: "",

                compareItems: [],

                category: [],

                trekvastheidData: {
                    value: [
                        0,
                        1400
                    ],
                    width: "100%",
                    height: 8,
                    dotSize: 16,
                    min: 0,
                    max: 1400,
                    disabled: false,
                    show: true,
                    useKeyboard: true,
                    tooltip: "always",
                    formatter: "{value}",
                    mergeFormatter: "{value1} ~ {value2}",
                    style: {
                        'color': "black"
                    },
                    bgStyle: {
                        "backgroundColor": "#eee",
                        "cursor": "pointer",
                        "border": "none",
                        "borderRadius": "0",
                        "height": "6px"

                    },
                    tooltipStyle: {
                        "backgroundColor": "#FFF",
                        "borderColor": "#FFF",
                        "color": "black",
                        "fontWeight": "600",
                        "fontSize": "16px",
                        "marginTop": "-15px",
                        //"position": "absolute",
                        "top": "-100%"
                    },
                    processStyle: {
                        "backgroundColor": "#E7581D",
                    },
                    sliderStyle: [
                        {
                            "backgroundColor": "black"
                        },
                        {
                            "backgroundColor": "black"
                        }
                    ]

                },

                gebruikshardheidData: {
                    value: [
                        0,
                        70
                    ],
                    width: "100%",
                    height: 8,
                    dotSize: 16,
                    min: 0,
                    max: 70,
                    disabled: false,
                    show: true,
                    useKeyboard: true,
                    tooltip: "always",
                    formatter: "{value}",
                    mergeFormatter: "{value1} ~ {value2}",
                    style: {
                        'color': "black"
                    },
                    bgStyle: {
                        "backgroundColor": "#eee",
                        "cursor": "pointer",
                        "border": "none",
                        "borderRadius": "0",
                        "height": "6px"

                    },
                    tooltipStyle: {
                        "backgroundColor": "#FFF",
                        "borderColor": "#FFF",
                        "color": "black",
                        "fontWeight": "600",
                        "fontSize": "16px",
                        "marginTop": "-15px",
                        //"position": "absolute",
                        "top": "-100%"
                    },
                    processStyle: {
                        "backgroundColor": "#E7581D",
                    },
                    sliderStyle: [
                        {
                            "backgroundColor": "black"
                        },
                        {
                            "backgroundColor": "black"
                        }
                    ]

                },

                data: {
                    category: [],

                    trekvastheid: [],
                    hardheid_hrc: [],

                    verspaanbaarheid: 0,
                    taaiheid: 0,
                    slijtvastheid: 0,
                    maatvastheid: 0,
                    corrosiebestendigheid: 0,
                }
            }
        },
        created: function () {
            console.dir(this.steels);
            this.allSteels = this.steels;

            if(sessionStorage.getItem('filterData')) {
                var data = JSON.parse(sessionStorage.getItem('filterData'));
                Object.assign(this.$data, data);
            }

        },
        mounted: function(){
            if(this.compareItems != []) {
                let holdSteels = this.compareItems;
                this.compareItems = [];
                for(let i = 0; i < holdSteels.length; i++) {
                    $("#"+holdSteels[i].id).click();
                }
            }
        },
        methods: {
            saveFilter: function() {
                sessionStorage.setItem('filterData', JSON.stringify(this.$data));
            },
            selectHandler: function() {
                return;
            },
            addRemoveCompare: function(steel) {
                if(!this.notInCompare(steel)) {
                    let index = this.compareItems.indexOf(steel);
                    this.compareItems.splice(index, 1);
                } else if (this.notInCompare(steel) && !this.maxCompareLength()) {
                    this.compareItems.push(steel);
                }
            },

            compareAvailable: function() {
                if(this.compareItems.length > 1) {
                    return true;
                }
                return false;
            },

            maxCompareLength: function() {
                if(this.compareItems.length === 3) {
                    return true;
                }

                return false;
            },
            notInCompare: function(steel) {
                let index = this.compareItems.indexOf(steel);

                if (index > -1) {
                    return false
                }

                return true
            },
            emptyCategoryArrays: function() {
                this.data.category = [];
                this.category = [];
            }
        },
        watch: {
            $data: {
                handler: function(val) {
                    sessionStorage.setItem('filterData', JSON.stringify(this.$data));
                } ,
                deep:true
            },
            showGebruikshardheid(val) {
                if (val) {
                    this.$nextTick(() => this.$refs.gebruikshardheid.refresh());
                }
            },

            showTrekvastheid(val) {
                if (val) {
                    this.$nextTick(() => this.$refs.trekvastheid.refresh());
                }
            },
            trekvastheidData: {
                handler: function (val) {
                    this.data.trekvastheid = val.value;
                },
                deep: true
            },
            gebruikshardheidData: {
                handler: function (val) {
                    this.data.hardheid_hrc = val.value;
                },
                deep: true
            },
            category: {
                handler: function(val) {
                    this.data.category = val;
                }
            }
        },
        computed: {
            activeSteels: function () {

                for (var key in this.data) {

                    if (typeof(this.data[key]) == "number") {
                        if (this.data[key] != 0) {
                            this.filtered = true;
                        }
                    } else {
                        if (this.data[key].length != 0) {
                            this.filtered = true;
                        }
                    }
                }

                if (this.filtered) {

                    var filtered = this.allSteels;

                    for (var key in this.data) {
                        if (typeof(this.data[key]) == "number") {
                            if (this.data[key] != 0) {
                                filtered = filter[key](filtered, key, this.data[key]);
                            }
                        } else {
                            if (this.data[key].length != 0) {
                                filtered = filter[key](filtered, key, this.data[key]);
                            }
                        }
                    }

                    return filtered;
                }

                return this.allSteels;

            },
            qualities: function() {
                if(this.searchType) {
                    let _this = this;

                    return this.allSteels.filter(function(value, key, collection){

                        if(value.type.toLowerCase().includes(_this.searchType.toLowerCase())) {
                           return value;
                        }

                        if(value.name.toLowerCase().includes(_this.searchType.toLowerCase())) {
                           return value;
                        }

                        if(value.aisi.toLowerCase().includes(_this.searchType.toLowerCase())) {
                           return value;
                        }

                        if(value.zoektermen) {
                            if(value.zoektermen.toLowerCase().includes(_this.searchType.toLowerCase())) {
                                return value;
                            }
                        }
                    }, _this);
                }

                return [];
            },
            IsFromSearchTerms: function() {
                if(this.searchType) {
                    let _this = this;
                    return this.allSteels.filter(function(value, key, collection){
                        if(value.zoektermen) {
                            return value.zoektermen.toLowerCase().includes(_this.searchType.toLowerCase());
                        }
                        return false;
                    });
                }
                return false;
            },
            names: function() {
                if(this.searchName) {
                    let _this = this;

                    return this.allSteels.filter(function(value, key, collection) {
                        if(value.name.toLowerCase().includes(_this.searchName.toLowerCase()) ||
                           value.zoektermen.toLowerCase().includes(_this.zoektermen.toLowerCase())) {
                            return value;
                        }
                    }, _this);
                }
            },
            availableToCompare: function() {
                return this.compareItems.length < 2;
            },
            maxCompareReached: function() {
                return this.compareItems.length == 3;
            }
        }
    }

</script>
<style>
    .activeFilter .filter-collapse-btn:before, .activeFilter .filter-collapse-btn:after {
        background-color: #e95701 !important;
    }
    .compare-text{
        margin-bottom: 25px;
        text-align: center;
        font-size: 16px;
        line-height: 23px;
        color: #e95800;
        font-weight: bold;
    }

    .compare-inactive{
        background-color: #E6E6E6;
        color: #bcbcbc;
        cursor: not-allowed;
        font-weight: 500;
    }

    .compare-select-text{
        font-size: 14px;
        font-weight: 500;
    }

    .verge-btn{
        padding: 5px 15px;
    }

    .vue-slider-dot-handle {
        background-color: #E95702 !important;
        box-shadow: none !important;
    }

    .vue-slider-component .vue-slider {
        height: 4px !important;
    }

    .vue-slider-dot {
        top: -6px !important;
    }

    .staalwijzer .left-sidebar .filter-section.rating .filter-section-body {
        display: block !important;
        height: auto !important;
    }
    .staalwijzer .left-sidebar .filter-section.rating .filter-collapse-btn {
        display: none !important;
    }
    .staalwijzer .filter-section.rating {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
    }
    .staalwijzer .left-sidebar .filter-section.rating .filter-section-header h5 {
        font-size: 16px;
    }
    .staalwijzer .left-sidebar .filter-section.rating:not(:nth-child(4)) {
        border-top: none;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/steelfilter/staalfilter.vue